// extracted by mini-css-extract-plugin
module.exports = {"icon":"TablePreviewButton_icon__qEuaC","popup":"TablePreviewButton_popup__I1ev_","message":"TablePreviewButton_message__FoO5l","visual":"TablePreviewButton_visual__8nmS4"};